import {http} from '../utils'
// 查询
const searchAction = (params) => {
  const url = `/market/management/sign/page`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/sign/save`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/management/sign/delete/${id}`
  return http.post(url)
}
// 新建
const defaultAction = (params) => {
  const url = `/market/management/sign/isDefault`
  return http.post(url, params)
}
// 获取group列表
const syncAction = () => {
  const url = '/market/management/sign/sync'
  return http.post(url)
}

export default {
  searchAction,
  getStatus,
  getGroup,
  addAction,
  deleteAction,
  defaultAction,
  syncAction
}
